import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types';
import { debounce } from '../../../helpers/index'
import Button from '../Button'
import FilterItem from './FilterItem'
import useExpandCollapse from '../../../helpers/reactHooks/useExpandCollapse'

const FilterList = ({
  filters,
  selectedFilters,
  onFiltersChange,
  onResetFilters,
  resetBtnLabel,
  loading,
  filterHeading
}) => {
  const breakpoint = window.matchMedia('(min-width: 1280px)');
  const filterListTrigger = useRef(null);
  const filterLists = useRef(null);
  const [displayFilters, setDisplayFilters] = useState(breakpoint.matches);

  useExpandCollapse(displayFilters, filterListTrigger, filterLists);

  useEffect(() => {
    const listener = () => {
      if (breakpoint.matches) {
        setDisplayFilters(true);
      } else {
        setDisplayFilters(false);
      }
    };

    debounce(window.addEventListener('resize', listener), 500);
    return () => window.removeEventListener('resize', listener);
  }, []);

  const onCleanFilters = () => {
    onResetFilters();
  };

  return (
    <div className="filter-list">
      {loading && <div className="loading"></div>}

      {filterHeading && <h4 className="filter-list__heading">{filterHeading}</h4> }

      {Object.keys(selectedFilters).length ? (
        <div className="filter-list__clear-button">
          <Button
            theme="secondary"
            label={resetBtnLabel}
            clickAction={onCleanFilters}
            small
          />
        </div>
      ) : (
        ''
      )}

      {filters && (
        <div className="accordion__item filter-list__main accordion__item--collapsed">
          <button
            className="accordion__item-trigger filter-list__main-button"
            aria-expanded="false"
            aria-controls="filtersList"
            ref={filterListTrigger}
            onClick={() => setDisplayFilters(!displayFilters)}
          >
            <div className="small-card-title">{displayFilters ? 'Hide Filters' : 'Show Filters'}</div>
            <span className="accordion__item-icon cta-decorator-v2">
              <svg viewBox="0 0 64 64">
                <use xlinkHref={displayFilters ? '#minus-icon-rebrand' : '#plus-icon-rebrand'}/>
              </svg>
            </span>
          </button>

          <div
            role="region"
            id="filtersList"
            className="accordion__item-content"
            aria-labelledby="filtersList"
            aria-hidden="true"
            ref={filterLists}
          >
            <div className="accordion__item-inner">
              <div className="accordion filter-list__inner">
                <div className="accordion__items">
                  {filters.map((filter, index) => (
                    <FilterItem
                      key={index}
                      filter={filter}
                      selected={selectedFilters[filter.keyword] || []}
                      onFilterChange={onFiltersChange}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

FilterList.propTypes = {
  filters: PropTypes.array,
  selectedFilters: PropTypes.object,
  onFiltersChange: PropTypes.func,
  onResetFilters: PropTypes.func,
  resetBtnLabel: PropTypes.string
};

export default FilterList;
